import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import OrgsTable from "./components/OrgsTable";
import OrgDetail from "./components/OrgDetail";
import SummaryTable from "./components/SummaryTable";
import TrelloCards from "./components/TrelloCards";
import Login from "./components/Login";
import PrivateRoute from "./components/PrivateRoute";
import ProtectedRoute from "./components/ProtectedRoute";
import Logout from "./components/Logout";
import AdminUsers from "./components/AdminUsers";
import ConfirmCode from "./components/ConfirmCode";
import FileUpload from "./components/FileUploadButton";
import SetInitialPassword from "./components/SetInitialPassword";
import Files from "./components/Files";
import { AuthProvider } from "./utils/AuthContext";
import AdminLogs from "./components/AdminLogs";
import Reports from "./components/Reports";
import ReportsTable from "./components/ReportsTable";
import MFR from "./config/manufacturers";

const ALL_ROLES = ["admin", "viewer", "team_member", "manager", "file_limited"];
const INTERNAL_ROLES = ["admin", "viewer", "team_member", "manager"];

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/confirm" element={<ConfirmCode />} />
        <Route
          path="/activate-account/:userId/:token"
          element={<SetInitialPassword />}
        />

        {/* All authenticated users */}
        <Route
          path="/"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          path="/logout"
          element={
            <PrivateRoute>
              <Logout />
            </PrivateRoute>
          }
        />

        {/* Orgs */}
        <Route
          path="/orgs"
          element={
            <ProtectedRoute
              component={OrgsTable}
              allowedRoles={INTERNAL_ROLES}
              allowedManufacturers={MFR.orgs}
              fallbackPath="/"
            />
          }
        />
        <Route
          path="/orgs/:orgId"
          element={
            <ProtectedRoute
              component={OrgDetail}
              allowedRoles={INTERNAL_ROLES}
              allowedManufacturers={MFR.orgs}
              fallbackPath="/"
            />
          }
        />

        {/* Summary */}
        <Route
          path="/summary"
          element={
            <ProtectedRoute
              component={SummaryTable}
              allowedRoles={INTERNAL_ROLES}
              allowedManufacturers={MFR.summary}
              fallbackPath="/"
            />
          }
        />

        {/* Tasks */}
        <Route
          path="/tasks"
          element={
            <ProtectedRoute
              component={TrelloCards}
              allowedRoles={ALL_ROLES}
              allowedManufacturers={MFR.tasks}
              fallbackPath="/"
            />
          }
        />

        {/* Files */}
        <Route
          path="/file/files"
          element={
            <ProtectedRoute
              component={Files}
              allowedRoles={ALL_ROLES}
              allowedManufacturers={MFR.files}
              fallbackPath="/"
            />
          }
        />

        {/* Reports */}
        <Route
          path="/reports"
          element={
            <ProtectedRoute
              component={Reports}
              allowedRoles={ALL_ROLES}
              allowedManufacturers={MFR.reports}
              fallbackPath="/"
            />
          }
        />
        <Route
          path="/reports-table"
          element={
            <ProtectedRoute
              component={ReportsTable}
              allowedRoles={ALL_ROLES}
              allowedManufacturers={MFR.reports}
              fallbackPath="/"
            />
          }
        />

        {/* Admin */}
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute
              component={AdminUsers}
              allowedRoles={["admin"]}
              allowedManufacturers={MFR.admin}
              fallbackPath="/"
            />
          }
        />
        <Route
          path="/admin/logs"
          element={
            <ProtectedRoute
              component={AdminLogs}
              allowedRoles={["admin"]}
              allowedManufacturers={MFR.admin}
              fallbackPath="/"
            />
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;
